import { keyframes } from '@emotion/react';
import type { HeadingProps, IntrinsicSystemProps } from '@hover/blueprint';
import { Heading, forwardRef, system } from '@hover/blueprint';
import React from 'react';

export interface LoadingTextProps extends HeadingProps {}

const bounce = keyframes`
  0% { opacity: 1; transform: translateY(0%); }
  25% { opacity: 0.6; transform: translateY(-5%); }
  50% { opacity: 1; transform: translateY(0%); }
  100% { opacity: 1; transform: translateY(0%); }
`;

export interface LoadingTextEllipsisProps
  extends IntrinsicSystemProps<'span'> {}

export const LoadingTextEllipsis = forwardRef<LoadingTextEllipsisProps, 'span'>(
  (props, ref) => (
    <system.span {...props} ref={ref}>
      {['.', '.', '.'].map((dot, index) => (
        <system.span
          animation={`${bounce} 1.5s ${index * 0.2}s infinite`}
          display="inline-block"
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        >
          {dot}
        </system.span>
      ))}
    </system.span>
  ),
);

const LoadingText = forwardRef<LoadingTextProps, 'h1'>(
  ({ children, ...props }, ref) => (
    <Heading {...props} ref={ref}>
      {children}
      <LoadingTextEllipsis />
    </Heading>
  ),
);

export { LoadingText };
